var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramBrands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.483887C6.71571 0.483887 0 7.19959 0 15.4839C0 23.7682 6.71571 30.4839 15 30.4839C23.2843 30.4839 30 23.7682 30 15.4839C30 7.19959 23.2843 0.483887 15 0.483887ZM21.9527 10.6851C21.727 13.057 20.7503 18.8128 20.2531 21.4694C20.0429 22.5934 19.6288 22.9703 19.2281 23.0072C18.3571 23.0874 17.6955 22.4315 16.8518 21.8785C15.5317 21.0131 14.7858 20.4743 13.5043 19.6299C12.0233 18.654 12.9834 18.1178 13.8274 17.2408C14.0483 17.0113 17.8863 13.5204 17.9606 13.2037C17.9698 13.1641 17.9787 13.0162 17.8908 12.9385C17.8028 12.8609 17.6736 12.8872 17.5802 12.9083C17.4478 12.9384 15.3388 14.3324 11.2531 17.0903C10.6545 17.5013 10.1123 17.7016 9.62643 17.6911C9.09085 17.6796 8.06063 17.3883 7.29472 17.1393C6.35534 16.834 5.60873 16.6726 5.67375 16.154C5.70762 15.8838 6.0796 15.6076 6.78968 15.3254C11.1625 13.4202 14.0784 12.1641 15.5373 11.5572C19.703 9.82453 20.5686 9.52356 21.1328 9.51352C21.2569 9.51147 21.5343 9.54219 21.714 9.68802C21.8335 9.7919 21.9097 9.93686 21.9275 10.0942C21.958 10.2896 21.9664 10.4878 21.9527 10.6851Z",
    fill: "url(#paint0_linear_78_55)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_55",
    x1: 31.4318,
    y1: 30.4839,
    x2: -1.50917,
    y2: 30.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455446,
    stopColor: "#02F781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FFF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30.9677,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBrands);
export default __webpack_public_path__ + "static/media/telegram-brands.fa8558cea4db0b1face6d33946cdee49.svg";
export { ForwardRef as ReactComponent };